export const searchFormOption = function () {
    return [
        {
            prop: 'date',
            label: '选择日期',
            type: 'range-date',
        },
        {
            prop: 'orgId',
            label: '所属机构',
            type: 'cascader',
            placeholder: '请选择所属机构',
            propConfig: {
                value: 'id',
                label: 'orgName',
                emitPath: false
            },
            options: this.orgOption
        },

    ]
}

export default {}